import KnowledgeExplorer from '../components/knowledge/KnowledgeExplorer';

/**
 * Route wrapper for `/knowledge` (spec §8.1). The app shell supplies the
 * `<main>` landmark and the provider stack (`SessionProvider` in particular,
 * which the embedded graph subsystem depends on), so the page itself only
 * mounts the explorer.
 */
export function KnowledgePage() {
  return <KnowledgeExplorer />;
}

export default KnowledgePage;
